import { ReactElement } from 'react'
import { SvgIcon } from '@mui/material'
import Icon from 'src/assets/icons/ifc_icon.svg?react'

const IFC = (): ReactElement => {
  return <SvgIcon component={Icon} inheritViewBox />
}

export default IFC
